import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { actions } from '../../store/actions';
import "./SnackBar.scss";

const Alert = React.forwardRef((props, ref) => <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />);

export default function Toaster() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const commonState = useSelector((state) => state.common);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    dispatch(actions.hideToast());
  };

  return (
    <div className='snackbar__container'>
      <Snackbar open={commonState.showToast} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={handleClose} severity={commonState.alertType} sx={{ width: '100%' }}>
          {t(commonState.message, commonState?.dynamicToastValue || "")}
        </Alert>
      </Snackbar>
    </div>
  );
}